import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";

const HomeContent = () => (
  <div className="next-steps">

    <h2 className="my-5 text-center">Hier findest Du alles, was Du brauchst, um die besten Restaurants ins Rampenlicht zu rücken und fantastische Produkte zu deserven.</h2>

    <div className="row">
      <div className="col-md-5 mb-4 mx-auto text-center">
        <h6 className="mb-3">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="/products"
          >
            <FontAwesomeIcon icon={faLink} className="mr-2" />
            Exklusive Angebote
          </a>
        </h6>
        <p>
          Teile aufregende Restaurant-Promotionen auf Social Media und entdecke neue kulinarische Highlights. 
        </p>
      </div>
    </div>
    <div className="row">
      <div className="col-md-5 mb-4 mx-auto text-center">
        <h6 className="mb-3">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="/products"
          >
            <FontAwesomeIcon icon={faLink} className="mr-2" />
            Spannende deserve Chancen
          </a>
        </h6>
        <p>
          Teile Beiträge, sammle Likes und sichere Dir großartige Köstlichkeiten.
        </p>
      </div>
    </div>
    <div className="row">
      <div className="col-md-5 mb-4 mx-auto text-center">
        <h6 className="mb-3">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="mailto:info@mydeserve.ch"
          >
            <FontAwesomeIcon icon={faLink} className="mr-2" />
            Professionelle Unterstützung
          </a>
        </h6>
        <p>
          Schreib uns eine Mail mit Deinem Anliegen und nutze unsere Tipps für effektive Social Media Beiträge.
        </p>
      </div>
    </div>
    <div className="row">
      <p>
      Deine Aktivität zählt! Mit jedem Share und Like machst Du Restaurants bekannt und erhöhst Deine deserve Chancen.{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://mydeserve.ch"
        >
          Mehr Informationen findest Du auf unserer Homepage.
        </a>
      </p>
    </div>
  </div>
);

export default HomeContent;
